import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getCurrentPage } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import Typography from "@insite/mobius/Typography";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import * as React from "react";
import { connect } from "react-redux";
import { css } from "styled-components";

const mapStateToProps = (state: ApplicationState) => ({
    pageTitle: getCurrentPage(state).fields.title,
});

type Props = WidgetProps & ReturnType<typeof mapStateToProps>;

export const checkOutFlowPageTitleStyles = {
    headingText: {
        size: 42,
        variant: "headerPrimary",
        weight: 700,
        css: css`
            text-transform: Uppercase;
            font-style: italic;
            ${({ theme }: { theme: BaseTheme }) => {
                return breakpointMediaQueries(theme, [
                    null,
                    null,
                    css`
                        font-size: 63px;
                    `,
                    css`
                        font-size: 63px;
                        padding-bottom: 17px;
                    `,
                    css`
                        font-size: 63px;
                        padding-bottom: 17px;
                    `,
                ]);
            }};
        `,
    },
};

const CheckOutFlowPageTitle: React.FunctionComponent<Props> = ({ pageTitle, fields }: Props) => (
    <Typography {...checkOutFlowPageTitleStyles.headingText} variant="h2" as="h1" data-test-selector="PageTitle">
        {fields.overrideTitle || pageTitle}
    </Typography>
);

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(CheckOutFlowPageTitle),
    definition: {
        group: "Basic",
        icon: "PageTitle",
    },
};

export default widgetModule;
